module.exports = __webpack_public_path__ + "static/img/role.7b26369.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/media5/role.png
// module id = FcHN
// module chunks = 7